<ion-header translucent>
  <ion-toolbar>
    <ion-title>Selecciona una ubicación</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">Cancelar</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div style="height: 100%; width: 100%;">
    <app-map
      [isWeb]="isWeb"
      [userLocation]="userLocation"
      [showRangeSelector]="showRangeSelector"
      [initialRange]="initialRange"
      (locationSelected)="locationSelected($event)"></app-map>
  </div>
</ion-content>
